import { Entity } from '@api';
import { AssetCard } from '@chart';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import clsx from 'clsx';
import { HtmlHTMLAttributes, ReactNode } from 'react';

import { ExchangeCard } from '../exchange-card/ExchangeCard';
import styles from './ListEntityItem.module.scss';

export interface ListEntityItemProps
  extends Omit<HtmlHTMLAttributes<HTMLButtonElement>, 'onFocus'> {
  entity: Entity;
  isFocused: boolean;
  highlighted?: string;
  snakeName?: string;
  onFocus?: (name: string) => void;
  actionNode?: ReactNode;
  isDisabled?: boolean;
}

export const ListEntityItem = ({
  entity,
  isFocused,
  isDisabled,
  highlighted,
  snakeName,
  actionNode,
  onFocus,
  ...rest
}: ListEntityItemProps) => {
  return (
    <button
      className={clsx(styles.listEntityItemRoot, {
        [styles.isFocused]: isFocused,
        [styles.isDisabled]: isDisabled,
      })}
      data-testid={`list-item-${entity.id}`}
      onFocus={() => onFocus?.(entity.name)}
      {...rest}
    >
      <div className={styles.leftPart}>
        {actionNode}
        <AssetCard
          logoNode={<AssetLogoContainer entity={entity} />}
          entity={entity}
          highlighted={highlighted}
          snakeName={snakeName}
        />
      </div>
      <div className={styles.details}>
        <ExchangeCard entity={entity} />
      </div>
    </button>
  );
};
